import { ReactElement } from "react";
import { IIndicatorResult } from "../../../../../services/http/indicatorlist/models/IIndicatorResult";
import IndicatorSemaphore from "../../../../../components/Shared/IndicatorSemaphore";
import IndicatorGauge from "../../../../../components/Shared/IndicatorGauge";
import styles from "./IndicatorHeader.module.scss";

interface IIndicatorHeaderProps
{
    indicator: IIndicatorResult;
    componentId: number;
    widgetId: number;
    displayGaugeInfo: boolean;
    displayGaugeGraphic: boolean;
}

function IndicatorHeader(props: IIndicatorHeaderProps): ReactElement
{
    return (
        <div className={styles.wrapper}>
            <h3>
                <span>{props.indicator.name}</span>

                {props.displayGaugeInfo && (
                    <IndicatorSemaphore
                        status={props.indicator.statusId}
                        score={props.indicator.score}
                        customClass={styles.scoreCustomSize}
                    />
                )}
            </h3>

            {props.displayGaugeGraphic && (
                <div className={styles.gaugeContainer}>
                    <IndicatorGauge
                        status={props.indicator.statusId}
                        score={props.indicator.score}
                        size="small"
                        stroke="small"
                    />
                </div>
            )}
        </div>
    );
}

export default IndicatorHeader;